import * as React from "react";
import { CorruptedGcpType } from "../../../apiFacades/bapi/gcpRequests";
import PlacedGCPIcon from "../../../react/icons/map/PlacedGCPIcon";
import { Black } from "@traceair/tds";
import GcpIcon from "../../../react/icons/map/GcpIcon";
import { getCorruptedIconColors } from "./flightMarkerIcon";
import { ExistingControlMarkerIcon } from "./ExistingControlMarkerIcon";

export type IMarkerIconParams =
  | {
      type: "gcp";
      corruptionType?: CorruptedGcpType;
    }
  | {
      type: "existing";
      isExistingHighPrio?: boolean;
      isSelected?: boolean;
    };

// in updated design, icons in the sidebar and on the map are a little different
// (map icons have outline)
export const GcpMapIcon = (params: IMarkerIconParams) => {
  switch (params.type) {
    case "gcp": {
      if (params.corruptionType != null) {
        const iconColors = getCorruptedIconColors(params.corruptionType);
        return (
          <GcpIcon
            color={iconColors.color}
            outlineColor={iconColors.outlineColor}
          />
        );
      }
      return <PlacedGCPIcon color={Black} />;
    }
    case "existing": {
      return (
        <ExistingControlMarkerIcon
          isExistingHighPrio={params.isExistingHighPrio}
          isSelected={params.isSelected}
        />
      );
    }
  }
};
